
const rootUrl = 'https://api.chicom.vn';

const postApi = rootUrl + '/wp-json/wp/v2/posts';
const pageApi = rootUrl + '/wp-json/wp/v2/pages';
const userApi = rootUrl + '/wp-json/wp/v2/users';
const catApi = rootUrl + '/wp-json/wp/v2/categories';
const sendEmail = rootUrl + '/wp-json/chimedia/v1/send'
const userName = 'masterusers';
const appPwd = 'u88o prUS 3FCd r0Wb KK9y LS3O';

export {postApi, pageApi, userApi, userName, appPwd, catApi, sendEmail};


// WEBPACK FOOTER //
// ./src/config/api.js